import { useContext, useState } from "react";
import type { CAPSDACFeatureFlags } from "@/models/feature-flag.ts";
import { useFeatureFlags, useUpdateFeatureFlag } from "@/queries";
import { FileSubmissionsContext } from "@/components/layout/FileSubmissionsTracker";

export default function useFeatureFlagsAdmin() {
  const flagsQuery = useFeatureFlags();
  const updateMutation = useUpdateFeatureFlag();
  const { showToast } = useContext(FileSubmissionsContext);
  const [pendingToggle, setPendingToggle] =
    useState<CAPSDACFeatureFlags | null>(null);

  const flags = flagsQuery.data ?? [];
  const error = flagsQuery.error ?? updateMutation.error;

  const handleToggleRequest = (flag: CAPSDACFeatureFlags) => {
    setPendingToggle(flag);
  };

  const handleCancelToggle = () => {
    setPendingToggle(null);
  };

  const handleConfirmToggle = () => {
    if (!pendingToggle) return;
    const flag = pendingToggle;
    setPendingToggle(null);
    updateMutation.mutate(
      { ...flag, isEnabled: !flag.isEnabled },
      {
        onSuccess: (saved) => {
          showToast(
            "success",
            "Feature Flag Updated",
            `"${saved.name}" is now ${saved.isEnabled ? "on" : "off"}.`
          );
        },
      }
    );
  };

  return {
    flags,
    isLoading: flagsQuery.isLoading,
    saving: updateMutation.isPending,
    error,
    pendingToggle,
    handleToggleRequest,
    handleCancelToggle,
    handleConfirmToggle,
  };
}
